import App from "./App";
export { store } from "./App";

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.ts